import { useAuth } from 'clients/auth.client'

type MenuType = {
  to: string
  text: string
}

const useAdminMenu = (): MenuType[] => {
  const { isAuthenticated, account } = useAuth()

  if (!isAuthenticated || account.role === 'user') {
    return []
  }

  return [
    {
      to: '/admin/users',
      text: 'Users',
    },
    {
      to: '/admin/events',
      text: 'Events',
    },
  ]
}

export default useAdminMenu
